import { Grid, createStyles, makeStyles } from '@material-ui/core';
import { FunctionComponent } from 'react';
import NauLogo from '../NauLogo';
import commonStyleRules from '../styles';

const RecoveryLayout: FunctionComponent = ({ children }) => {
  const useStyles = makeStyles((theme) => createStyles(commonStyleRules(theme)));
  const { header, left } = useStyles();
  return (
    <Grid container item direction="column" md={5} wrap="nowrap" className={left}>
      <Grid className={header} container item justifyContent="space-between" wrap="nowrap">
        <NauLogo />
      </Grid>
      {children}
    </Grid>
  );
};

export default RecoveryLayout;
